<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     阶梯价格设置
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    width="600px"
    title="阶梯价格设置"
    :visible.sync="dialogShow"
    append-to-body
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <div style="width: 450px; margin: 20px auto">
      <div class="info mb-md">
        <div class="text-black">商品规格：<span class="text-primary">{{ activeSkuInfo.title }}</span></div>
        <div class="text-black mt-sm">售卖价格：<span class="text-primary font-md">￥{{ activeSkuInfo.price || '--' }}</span></div>
      </div>
      <el-table :data="activePrices">
        <el-table-column width="10" />
        <el-table-column label="等级">
          <template slot-scope="scope">
            <el-rate
              v-model="scope.row.level"
              disabled-void-color="transparent"
              disabled>
            </el-rate>
          </template>
        </el-table-column>
        <el-table-column label="单价" align="center">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <div class="money-icon">￥</div>
              <el-input-number placeholder="请输入单价" :controls="false" :min="0.01" :precision="2" v-model="scope.row.price">
              </el-input-number>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="flex-center mb">
      <el-button class="extend" @click="dialogShow = false">取消</el-button>
      <el-button class="extend" type="primary" @click="submit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TierPricingSetting',

  components: {
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    skuid: {
      type: Number,
      default: undefined
    },
    
    activeSkuInfo: {
      type: Object,
      default: () => ({})
    },

    index: {
      type: Number,
      default: undefined
    },

    advanced_prices: {
      type: Array,
      default: () => []
    },


  },

  data() {
    return {
      activePrices: [
        { price: undefined, level: 1 },
        { price: undefined, level: 2 },
        { price: undefined, level: 3 },
        { price: undefined, level: 4 },
        { price: undefined, level: 5 }
      ],
      posting: false
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  created() {
    if (this.advanced_prices.length) {
      this.activePrices = this.advanced_prices
    }
  },

  methods: {
    submit() {
      const arr = this.activePrices.filter(item => item.price)
      if (arr.length && arr.length < 5) {
        this.$message.error('请填写完整阶梯价格')
        return
      }
      this.dialogShow = false
      // console.log(this.activePrices)
      this.$emit('submit', { skuid: this.skuid, index: this.index, advanced_prices: arr.length ? this.activePrices : [] })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 0px 20px 20px;
}
/deep/ .el-input-number {
  .el-input {
    .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
.info {
  border-radius: 6px;
  background-color: rgba(238,240,245,1);
  padding: 20px;
  line-height: 20px;
}
.money-icon {
  width: 60px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #97999d;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border: 1px solid #dcdfe6;
  border-right: none;
  background-color: #f6f7f8;
}

</style>
